import React from "react";
import { useLocation } from "react-router-dom";
import RegionTable from "../../components/RegionTable";
import { Range } from "../../utils/range";
import { useOptionRegion } from "../../utils/options";

function Region() {
  const location = useLocation();
  const options = useOptionRegion();
  
  const getTempo = (): Range => {
    const path = location.pathname;
    const matchedOption = (options as any).find((opt: any) => path.includes(opt.value.replace("/region/", "")));
    return matchedOption?.range || Range.Direct;
  };

  const tempo: Range = getTempo();

  return <RegionTable tempo={tempo} />;
}

export default Region;
